export default __webpack_public_path__ + "static/media/clem.c740f06d.JPG";